module.exports = __webpack_public_path__ + "img/logo-shiba888.9c134f7f.png";